import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search, X, ArrowUpRight } from "lucide-react";
import { searchIndex } from "../mock";

const SearchOverlay = ({ open, onClose }) => {
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  const inputRef = useRef(null);

  useEffect(() => {
    if (open) {
      setQuery("");
      setTimeout(() => inputRef.current?.focus(), 60);
    }
  }, [open]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  const results = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return searchIndex.slice(0, 6);
    return searchIndex
      .map((item) => {
        const hit =
          item.title.toLowerCase().includes(q) ||
          item.keywords.some((k) => k.includes(q));
        const score =
          (item.title.toLowerCase().startsWith(q) ? 3 : 0) +
          (item.title.toLowerCase().includes(q) ? 2 : 0) +
          item.keywords.filter((k) => k.includes(q)).length;
        return hit ? { ...item, score } : null;
      })
      .filter(Boolean)
      .sort((a, b) => b.score - a.score);
  }, [query]);

  const goto = (route) => {
    onClose?.();
    navigate(route);
  };

  if (!open) return null;

  return (
    <div
      className="search-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Search"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div className="search-panel">
        <div className="search-bar">
          <Search size={22} className="search-bar-icon" />
          <input
            ref={inputRef}
            className="search-input"
            placeholder="Search TMM \u2014 try music, moments, tickets, hoodie..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && results[0]) goto(results[0].route);
            }}
          />
          <button className="search-close" onClick={onClose} aria-label="Close search">
            <X size={20} />
          </button>
        </div>
        <div className="search-results">
          {results.length === 0 ? (
            <div className="search-empty">No matches. Try another keyword.</div>
          ) : (
            results.map((r) => (
              <button
                key={r.route}
                className="search-result"
                onClick={() => goto(r.route)}
              >
                <span className="search-result-title">{r.title}</span>
                <span className="search-result-route">{r.route}</span>
                <ArrowUpRight size={18} />
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default SearchOverlay;
